import { useEffect, useState } from 'react';
import { useCreateAddons } from '@hooks/addons/use-create-event-addons';
import { useGetAddonsPresets } from '@hooks/addons/use-get-addons-presets';

import { AddOnsPresetsModalContent } from './components/add-ons-presets-modal-content';
import { AddOnsPresetsModalProps } from './add-ons-presets-modal.type';

export const AddOnsPresetsModal = ({
  isOpen,
  onClose,
  eventId,
  companyClubId,
  onSaved,
  surfaceClassName,
  zIndex,
}: AddOnsPresetsModalProps) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const { data: presets, isLoading } = useGetAddonsPresets({
    companyClubId,
    params: { eventId, isAssigned: false },
    enabled: isOpen,
  });
  const { mutate: createAddons, isPending } = useCreateAddons();

  useEffect(() => {
    if (isOpen) setSelectedIds([]);
  }, [isOpen]);

  const handleToggle = (id: string) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((value) => value !== id) : [...prev, id]));
  };

  const handleSave = () => {
    createAddons(
      { eventId, addOnPresetsId: selectedIds },
      {
        onSuccess: (created) => {
          onSaved?.(created.map((addon) => addon.id));
          onClose();
        },
      }
    );
  };

  return (
    <AddOnsPresetsModalContent
      isOpen={isOpen}
      onClose={onClose}
      presets={presets ?? []}
      isLoading={isLoading}
      selectedIds={selectedIds}
      onToggle={handleToggle}
      onSave={handleSave}
      isSaving={isPending}
      surfaceClassName={surfaceClassName}
      zIndex={zIndex}
    />
  );
};
